<template>
  <main>
    <b-container>
        <div class="page-breadcrumb">
            <router-link :to="{ name: 'ManageAccess' }"
                ><i class="fa fa-angle-left" /> Back to Manage Access</router-link
            >
        </div>

        <div class="section-header">
            <h1 class="heading">Update Realm User</h1>

            <div class="actions"></div>
        </div>

        <div class="layoutcard">
                <b-row>
                    <b-col cols="8" lg="7">
                        <b-form @submit.prevent="submit">
                        <b-row>

                            <b-col cols="6">
                                <b-form-group
                                id="input-group-first-name"
                                label="First name"
                                label-for="input-first-name"
                                >
                                <b-form-input
                                    id="input-first-name"
                                    v-model.trim="form.firstName"
                                    v-validate="{ required: true, max: 100 }"
                                    type="text"
                                    placeholder="First name"
                                    size="lg"
                                    data-vv-name="first-name"
                                ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group
                                id="input-group-last-name"
                                label="Last name"
                                label-for="input-last-name"
                                >
                                <b-form-input
                                    id="input-last-name"
                                    v-model.trim="form.lastName"
                                    v-validate="{ required: true, max: 100 }"
                                    type="text"
                                    placeholder="Last name"
                                    size="lg"
                                    data-vv-name="last-name"
                                ></b-form-input>
                                </b-form-group>
                            </b-col>


                            <b-col cols="12">
                              <b-form-group label="User Role" v-slot="{ ariaDescribedby }">
                                <b-form-radio-group
                                  id="radio-group"
                                  v-model="form.role"
                                  :options="options"
                                  :aria-describedby="ariaDescribedby"
                                  name="radio-options"
                                ></b-form-radio-group>
                              </b-form-group>
                            </b-col>

                            <b-col class="text-right" cols="12">
                                <div class="form-footer">
                                <b-btn variant="primary" size="lg" type="submit">
                                    <i class="fa fa-plus" /> Update
                                </b-btn>
                                </div>
                            </b-col>
                        </b-row>
                        </b-form>
                    </b-col>
                </b-row>
        </div>
    </b-container>
  </main>
</template>

<script>
import { setTimeout } from "timers";
import { mapActions, mapState } from "vuex";
import InitAdmin from "../Shared/InitAdmin";

export default {
  name: "UserCreate",
  components: {
  },
  extends: InitAdmin,
  data() {
    return {
      form: {
        firstName: null,
        lastName: null,
        role: null
      },
      options: [
        { text: 'Admin', value: 'admin' },
        { text: 'Full Access', value: 'normal' },
        { text: 'Discover Only', value: 'discover' }
      ]
    };
  },
  computed: {
    ...mapState({
      realms: (state) => state.realm.realms,
      realmUsers: (state) => state.realm.realmUsers
    }),
    realmUser() {
        return this.realmUsers.find(ru => { return ru._id === this.$route.params.id })
    },
    realmOptions() {
      return this.realms ? this.realms.map(realm => { return {text:realm.companyname, value:realm.companyname} }) : null;
    },
  },
  mounted() {
    this.form = this.realmUser;
  },
  methods: {
    ...mapActions(["updateRealmUser"]),
    submit() {
      let data = {
        id: this.form._id,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        role: this.form.role
      };

      this.updateRealmUser({
        user: data
      }).then(res => {
        console.log(res);
        this.$toasted.show("Realm User updated!");
        setTimeout(() => {
          this.$router.push({ name: "ManageAccess" });
        }, 1000);
      });
    }
  }
};
</script>